import React, { useRef } from 'react';
import EventEmitter from 'src/utils/EventEmitter';
import { useAuth0 } from "@auth0/auth0-react";

const LogoutNotificationPage = (props) => {
  const swipeAddonRef = useRef(null);
  const { logout } = useAuth0();

  const onLogout = () => {
    localStorage.removeItem('impersonate-token');
    logout({logoutParams: { returnTo: window.location.origin }});
  }

  const onMouseLeave = (e) => {
    if (swipeAddonRef.current) {
      var new_moveY = e.clientY;
      var swipe_move = swipeAddonRef.current.getBoundingClientRect();
      var swipe_moveY = swipe_move.y;

      if (new_moveY < swipe_moveY) {
        EventEmitter.emit("show_notification", { value: false, type: null });
      }
    }
  }

  return (
    <div className="notification-popup-container-content-wrapper-background-2">
      <div className="logout-container">
        <div ref={swipeAddonRef} className="swipe_addon-container" onMouseLeave={(e) => onMouseLeave(e)}>
          <div className="swipe-addon-indicator"></div>
        </div>
        <div className="logout-text-container">
          <div className="logout-text">Log out</div>
          <div className="logout-sub-text">Are you sure you want to log out?</div>
        </div>
        <div className="logout-button-container">
          <div className="logout-button-container-wrapper">
            <div className="logout-button-list">
              <button className="logout-button" onClick={() => onLogout()}>Logout</button>
            </div>
            <div className="logout-button-list">
              <button className="logout-button cancel" onClick={() => props.closeNotification()}>Cancel</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogoutNotificationPage;